import { useContext, useEffect, useState } from "react";
import ls from "local-storage";
import { useLocation } from "react-router-dom";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { IconButton } from "@material-ui/core";

import { StoreContext } from "../../../store/context";

import { useThemeStyles } from "../../../styles/themes";
import { hasBoostConnectUrlParams } from "../../../utils";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import LinkBankAccount from "../../../components/app/Step8Mandate/LinkBankAccount";
import RepaymentMethodV1 from "../../../components/app/Step8Mandate/RepaymentMethodV1";
import RepaymentMethodV2 from "../../../components/app/Step8Mandate/RepaymentMethodV2";

import "./Step8Mandate.scss";

const Step8Mandate = (props) => {
  const { currentStep, totalSteps, stepText, analyticsStep } = props;

  const classes = useThemeStyles();
  const { state, actions } = useContext(StoreContext);
  const params = new URLSearchParams(useLocation().search);

  // const [isBoostJourney, setIsBoostJourney] = useState(!!state.piiData);
  const [isLinkBankShow, setIsLinkBankShow] = useState(false);

  const handleSetupMandate = () => {
    ls.set("bnplstate", state);

    // AnalyticsStep: End step
    analyticsStep.handleStepEnd();

    actions.initialMandatev2({
      applicationId: state.applicationId,
      redirectUrl: `${window.location.href.split("?")[0]}`
    });
  };

  const handleShowLinkBank = () => setIsLinkBankShow(!isLinkBankShow);

  const renderRepaymentContent = () => {
    if (isLinkBankShow) {
      return <LinkBankAccount />;
    }

    const RepaymentScreen = state?.isRepaymentMethodV2Enable ? RepaymentMethodV2 : RepaymentMethodV1;

    // change to something decide to show new
    return <RepaymentScreen handleSetupMandate={handleSetupMandate} handleShowLinkBank={handleShowLinkBank} />;
  };

  useEffect(() => {
    if (state.applicationId) {
      // For direct debit card
      if (hasBoostConnectUrlParams(params)) {
        // AnalyticsStep: Import state
        analyticsStep.importStateLS();

        actions.setStep("MandateLoading");

        return;
      }

      // For bank account (CURLEC)
      if (params.get("fpx_debitAuthCode")) {
        analyticsStep.importStateLS();

        const data = {
          applicationId: state.applicationId,
        };
        actions.getMandateStatus(data);
        ls.remove("bnplstate");
      }
    }
  }, []);

  return (
    state.prerequisites
    && (
      <>
        <Header />
        <div className="page page-mandate">
          <div className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}>

            {isLinkBankShow && (
              <IconButton className="btn-back" onClick={handleShowLinkBank} style={{ visibility: "visible" }}>
                <img alt="back" src="/images/left-arrow-grey.svg" />
              </IconButton>
            )}

            {stepText && (
              <div className="stepper-holder">
                <span className={`${classes.stepText} step-text`}>
                  {stepText}
                </span>
                {/* {state.prerequisites?.themingConfigurations?.asset?.lockIconUrl && <img className="step-icon" alt="lock" src={state.prerequisites?.themingConfigurations?.asset.lockIconUrl} />} */}
                <img className="step-icon" alt="lock" src="https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210817/icon/0cb37674-336d-4f5d-a77d-2af6a74ad0ea/lock_icon_red.svg" />
              </div>
            )}

            {renderRepaymentContent()}

            <p className="contact-us">
              If your bank is unavailable, contact us at:
              <br />
              <a className="contact-link" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</a>
            </p>

          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(Step8Mandate, {
  stepId: "Step8Mandate",
  capturingFieldNames: [],
  importStateBeforeStepStart: false, // manually import for after mandate
  exportStateAfterStepEnd: true,
});
